// Carga Leaflet una sola vez desde el CDN (sin dependencia de npm: los mapas
// base ya vienen de internet vía OpenStreetMap) y avisa cuando está listo.
// Compartido por cualquier pantalla que necesite un mapa (Choferes en vivo,
// resolución de geolocalización, etc.) para no repetir la carga del script.
import { useEffect, useState } from "react";

const LEAFLET_JS = "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/leaflet.min.js";
const LEAFLET_CSS = "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/leaflet.min.css";

export function useLeaflet(): boolean {
  const [listo, setListo] = useState<boolean>(() => typeof (window as any).L !== "undefined");

  useEffect(() => {
    if (listo) return;
    if (!document.querySelector(`link[href="${LEAFLET_CSS}"]`)) {
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = LEAFLET_CSS;
      document.head.appendChild(link);
    }
    const yaCargando = document.querySelector(`script[src="${LEAFLET_JS}"]`) as HTMLScriptElement | null;
    const script = yaCargando ?? Object.assign(document.createElement("script"), { src: LEAFLET_JS, async: true });
    const alCargar = () => setListo(true);
    script.addEventListener("load", alCargar);
    if (!yaCargando) document.head.appendChild(script);
    return () => script.removeEventListener("load", alCargar);
  }, [listo]);

  return listo;
}
